module.exports = __webpack_public_path__ + "static/media/pickup_active.6e2f5bd4.svg";